module.exports = __webpack_public_path__ + "static/media/05.55c5621a.jpg";